import React from 'react';
import { Dropdown } from 'react-bootstrap';

const DropdownButton = ({ selectedCategory, setSelectedCategory, categoryNames }) => {
  if (!selectedCategory || !categoryNames[selectedCategory]) return null;

  return (
    <Dropdown className="mb-4 text-center">
      <Dropdown.Toggle
        style={{
          backgroundColor: '#000000', // true black
          color: 'white',
          border: 'none',
          width: '220px',
          borderRadius: '10px',
          padding: '12px 24px',
          height: '50px',
          fontSize: '1.2rem',
          transition: 'all 0.3s ease-in-out'
        }}
      >
        {categoryNames[selectedCategory]}
      </Dropdown.Toggle>

      <Dropdown.Menu className="text-center">
        {Object.entries(categoryNames).map(([key, label]) => (
          <Dropdown.Item
            key={key}
            onClick={() => setSelectedCategory(key)}
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownButton;
